import React from "react";
import { Icon } from "@dc/react-components";
import { Svg } from "../../../ws10";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import { trackView } from "@dc/utag-tracking";

function Tile(data) {
  return (
    <div className={data.cardBackground}>
      <div className="cards__copy-container">
        <h5 className="heading cards__subtitle">{data.cardHeading}</h5>
      </div>
      <div className="cards__image-container">
        <img className={data.imageClassName} src={data.imageUrl} />
      </div>
      <div className="cards__copy-container">
        <h4 className="heading heading--4 cards__title">{data.cardTitle}</h4>
        <h5 className="heading cards__subtitle">{data.cardSubtitle}</h5>
        <a className="heading cards__link" onClick={data.onHandleClick}>
          <span className="tiles__chevron--text ">
            {data.cardButtonText}
            <Icon Source={Svg.ChevronRight} className="icon--extra-small chevron__icon" />
          </span>
        </a>
      </div>
    </div>
  );
}

function Tiles({ tiles }) {
  const history=useHistory()
  return (
    <div className="cards" style={{ padding: 0 }}>
      <div className="cards__column">
        <Tile
          cardBackground={tiles[0].cardBackground}
          cardHeading={tiles[0].cardHeading}
          imageClassName={tiles[0].imageClassName}
          imageUrl={tiles[0].imageUrl}
          cardTitle={tiles[0].cardTitle}
          cardSubtitle={tiles[0].cardSubtitle}
          cardButtonText={tiles[0].cardButtonText}
          onHandleClick={()=>{if(tiles[0].cardTitle=='Samsung S10 Blue 64GB') history.push('?i_code=consumer-home-popular_banner-samsung_s10'); trackView()}}
        />
      </div>

      <div className="cards__column cards__column--wrap">
        {tiles.length > 1 &&
          tiles.map(function (tile, index) {
            if (index > 0)
              return (
                <Tile
                  key={index}
                  cardBackground={tile.cardBackground}
                  cardHeading={tile.cardHeading}
                  imageClassName={tile.imageClassName}
                  imageUrl={tile.imageUrl}
                  cardTitle={tile.cardTitle}
                  cardSubtitle={tile.cardSubtitle}
                  cardButtonText={tile.cardButtonText}
                />
              );
          })}
      </div>
    </div>
  );
}

Tiles.propTypes = {
  tiles: PropTypes.array.isRequired
};

export default Tiles;
